export default "/kiban/_next/static/images/line-b5d9f7ed7077b3a0bde298eacd8b7158.png";